import { Component } from '@angular/core';
import { IdentityService } from './core/identity/identity.service';


@Component({
    selector: 'app-should-login',
    template: `<p class="alert alert-info">Your session expired.</p>
    <p>Please <a href="" (click)="login($event)">log in</a> before continuing.</p>`,
    standalone: false
})
export class ShouldLoginComponent {
  constructor(private authService: IdentityService) { }

  public login($event) {
    $event.preventDefault();

    window.location.replace("/");
  }
}